import React, {useCallback} from "react";
import { makeStyles } from 'tss-react/mui';

// core components
import Header from "../../components/Header/Header.js";
import Footer from "../../components/Footer/Footer.js";
import HeaderLinks from "../../components/Header/HeaderLinks.js";
import Parallax from "../../components/Parallax/Parallax.js";
import logo from "../../public/img/logo.png";

import styles from "../../styles/jss/nextjs-material-kit/pages/articleStyle.js";

// Sections for this page
import ArticleList from "../../pages-sections/ArticleList.js";
import PreFooter from "../../pages-sections/LandingPage-Sections/PreFooter.js";
import JobsSidebar from "../../pages-sections/JobsSidebar.js";
import Grid from "@mui/material/Grid";
import Head from "next/head";
import {client} from "../../request/client";
import {buildSlug} from "../../util/url";
import {SWRConfig} from "swr";
import {useQueryState} from "nuqs";
import AdviceSearch from "../../components/AdviceSearch/AdviceSearch";
import JSONSchemaData from "../../components/JSONSchemaData/JSONSchemaData";
import {GPTProvider, GPTSlot} from "goopubtag";

const dashboardRoutes = [];

const useStyles = makeStyles()(styles);

function Advice(props) {
  const [query, setQuery] = useQueryState('q')

  const { classes, cx } = useStyles();
  const { category, ...rest } = props;

  const jsonBreadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://successatschool.org/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "Advice",
      "item": `https://successatschool.org/advice`,
    }, {
      "@type": "ListItem",
      "position": 3,
      "name": category.name,
      "item": `https://successatschool.org/advice/${buildSlug(category.name)}`,
    }]};

  return (
    <div className={cx(classes.white_bg, "employers")}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        {...rest}
      />
      <Head>
        <link rel="canonical" href={`https://successatschool.org/advice/${buildSlug(category.name)}`} />
        <title>{`${category.name} - Advice - Success at School`}</title>
      </Head>
      <Parallax
        className="parallaxx-compact"
        filter
        image="/img/faces/advice_main_bg.png"
      >
        <AdviceSearch query={query} setQuery={setQuery} />
      </Parallax>

      <div className={cx(classes.section, classes.white_bg, "jobbs")}>
        <div className={cx(classes.container)}>
          <GPTProvider networkId={108480305}>
            <GPTSlot slotId="job-listing-ad" adUnit="Leaderboard_Advice" sizes={[728, 90]} fallback="expand" className={classes.advert} />
          </GPTProvider>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} sm={12} md={8}>
              <h1
                className={cx(
                  classes.title,
                  classes.cardTitle2
                )}
              >
                {category.name}
              </h1>

              <ArticleList article_type='advice' query={query} category_id={category.id} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} className={classes.jobSidebar}>
              <JobsSidebar />
            </Grid>
          </Grid>
        </div>
      </div>

      <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
        <PreFooter />
      </div>
      <Footer />
      <JSONSchemaData key_name={'breadcrumbSchema'} data={jsonBreadcrumbData} />
    </div>
  );
}

export default function AdviceSwr({ fallback, ...rest }) {
  return (
      <SWRConfig value={{ fallback }}>
        <Advice {...rest} />
      </SWRConfig>
  );
}

export async function getServerSideProps({ query }) {
  const { category } = query;

  try {
    const categoryData = await client({
      url: `/v1/articles/categories/tool/${category}`,
      method: "get",
      headers: {},
    }).then((res) => res.data);

    return {
      props: {
        fallback: {
        //   [`/v1/articles/categories/tool/${category}`]: data,
        },
        category: categoryData,
      }
    };
  }
  catch (e) {
    if (e.response && e.response.status === 404) {
      return {
        notFound: true,
      };
    }
    else {
      throw e;
    }
  }
}